import React from "react";
import { Col, Card, ProgressBar } from "react-bootstrap";
import EmptyState from "./EmptyState";

const TopSectors = ({ data }) => {
  const hasData = data?.length > 0;

  return (
    <Col md={6} className="mb-4">
      <Card style={{ minHeight: "360px" }}>
        <Card.Body>
          <h6 className="fw-bold text-muted mb-2">{`Top Targeted Sectors`}</h6>
          {!hasData ? (
            <EmptyState title="No sectors found" />
          ) : (
            data.map((val, i) => (
              <div key={i} className="mb-3">
                <div className="d-flex justify-content-between">
                  <span className="inline-block small">
                    {val?.sector?.match(/[A-Z][a-z]+|[0-9]+/g)?.join(" ")}
                  </span>
                  <span className="inline-block p fw-bold">
                    {Math.round(val?.percentage)}%
                  </span>
                </div>
                <ProgressBar
                  now={val?.percentage}
                  label={`${val?.percentage}%`}
                  visuallyHidden
                />
              </div>
            ))
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default TopSectors;
